module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/default_cover-c0c92198b69e18545c621ba4a77a1fd1.png";